export default __webpack_public_path__ + "static/media/socials.7d686a86.svg";